import App from './App.vue';
import router from './router';
import { createApp } from 'vue';
import mitt from 'mitt';
import { vOnClickOutside, vInfiniteScroll } from '@vueuse/components';
import { QuillEditor } from '@vueup/vue-quill';
import VueDatePicker from '@vuepic/vue-datepicker';
import Toast from 'vue-toastification';
import Vue3ColorPicker from 'vue3-colorpicker';
import FloatingVue from 'floating-vue';
import { polyfillClipboard } from '@/composables/polyfill-clipboard';
import BodyScrollLock from '@/directives/body-scroll-lock';
import { options } from '@/constants/toast-variables';
import i18n from '@/i18n';

import '@/assets/css/styles.scss';

export const emitter = mitt();

const app = createApp(App)
    .use(router)
    .use(Toast, options)
    .use(Vue3ColorPicker)
    .use(i18n)
    .use(FloatingVue)
    .provide('emitter', emitter)
    .directive('click-outside', vOnClickOutside)
    .directive('infinite-scroll', vInfiniteScroll)
    .directive(BodyScrollLock.name, BodyScrollLock.directive)
    .component('VueDatePicker', VueDatePicker)
    .component('QuillEditor', QuillEditor);

app.mount('#app');
polyfillClipboard();

window.localStorage.setItem(import.meta.env.VITE_VERSION_KEY, import.meta.env.VITE_VERSION);
